module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "minitoc notoc",
    attrs: {
      "data-pdf-bookmark": "Mini TOC",
      "data-type": "preface",
      "epub:type": "preface"
    }
  }, [_c('div', {
    staticClass: "preface",
    attrs: {
      "id": "d13e19"
    }
  }, [_c('h1', {
    staticClass: "ChapTitleNonprintingctnp",
    attrs: {
      "data-displayheader": "no"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/toc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini TOC")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.5em"
    }
  }, [_c('a', {
    staticClass: "spanhyperlinkurl",
    attrs: {
      "href": "#/ch01#d1e240",
      "id": "beginreading"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.5em"
    }
  }, [_c('span', {
    staticClass: "spanhyperlinkurl",
    attrs: {
      "href": "#/toc01#z_TOC",
      "id": "toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.5em"
    }
  }, [_c('span', {
    staticClass: "spanhyperlinkurl",
    attrs: {
      "href": "#/app02#d1e5869",
      "id": "abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.5em"
    }
  }, [_c('a', {
    staticClass: "spanhyperlinkurl",
    attrs: {
      "href": "#/copyrightpage01#d1e84",
      "id": "copyright-page"
    }
  }, [_vm._v("Copyright Page")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5509ac1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface01.vue
// module id = 63
// module chunks = 0